<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card figma-role-layout">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('role.title') }}</div>
        <div class="figma-header-divider"></div>
      </div>

      <div class="figma-role-content">
        <div class="figma-role-left">
          <role-div @switch-role="handleSwitchRole" />
        </div>
        <div class="figma-role-right">
          <div class="figma-role-detail">
            <div class="figma-role-detail-title">{{ currentRole.name || $t('role.title') }}</div>
            <div class="figma-role-detail-divider"></div>
            <div class="figma-role-tabs">
              <button :class="['figma-tab-btn', activeTab === 'privilege' ? 'figma-tab-btn-active' : '']" @click="changeTab('privilege')">
                {{ $t('role.privilege') }}
              </button>
              <button :class="['figma-tab-btn', activeTab === 'staff' ? 'figma-tab-btn-active' : '']" @click="changeTab('staff')">
                {{ $t('role.staff') }}
              </button>
            </div>

            <div class="figma-role-tab-content">
              <div v-if="activeTab === 'privilege'">
                <privilege-tree :pg-id="currentRole.pgId" />
              </div>
              <div v-if="activeTab === 'staff'">
                <role-staff :pg-id="currentRole.pgId" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoleDiv from '@/components/role/RoleDiv'
import PrivilegeTree from '@/components/role/PrivilegeTree'
import RoleStaff from '@/components/role/RoleStaff'

export default {
  name: 'RoleList',
  components: {
    RoleDiv,
    PrivilegeTree,
    RoleStaff
  },
  data() {
    return {
      activeTab: 'privilege',
      currentRole: {
        pgId: ''
      }
    }
  },
  methods: {
    handleSwitchRole(role) {
      this.currentRole = role
      this.changeTab('privilege')
    },
    changeTab(tabName) {
      this.activeTab = tabName
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 0 24px; gap: 12px; }
.figma-page-title { font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin-bottom: 8px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 0; }
.figma-role-content { display: flex; flex: 1; padding: 16px 24px 24px 24px; gap: 16px; overflow: hidden; }
.figma-role-left { width: 220px; min-width: 220px; flex-shrink: 0; }
.figma-role-right { flex: 1; overflow: auto; }
.figma-role-detail { background: #F8FBFF; border: 1px solid #DCE6F5; border-radius: 8px; padding: 20px; min-height: 100%; }
.figma-role-detail-title { font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin-bottom: 12px; }
.figma-role-detail-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 16px; }
.figma-role-tabs { display: flex; gap: 8px; margin-bottom: 16px; }
.figma-tab-btn { padding: 8px 20px; border-radius: 10px; border: 1px solid #DCE6F5; background: white; color: #6A7282; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s; }
.figma-tab-btn:hover { border-color: #0E76FF; color: #0E76FF; }
.figma-tab-btn-active { background: #0E76FF !important; border-color: #0E76FF !important; color: white !important; }
.figma-role-tab-content { min-height: 300px; }
</style>
